import React, {useState} from 'react';
import { useHistory, useParams } from 'react-router-dom';
import {useSelector} from "react-redux";

import MainToolbar from '../MainToolbar';
import { t } from '../common/LocalizationProvider';
import { useEffectAsync } from '../reactHelper';
import SettingsDrawer from "./SettingsDrawer";
import { cyberStyles } from '../cssShared/cyberTheme';

import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import {Portal, Snackbar, useMediaQuery, useTheme} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import CircularProgress from "@material-ui/core/CircularProgress";
import CssBaseline from "@material-ui/core/CssBaseline";

const useStyles = makeStyles(theme => ({
  ...cyberStyles(theme),
  content: {
    flexGrow: 1,
    overflow: 'auto',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  container: {
    paddingBottom: theme.spacing(10),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
}));

const EditItemView = ({ children, endpoint, item, setItem }) => {
  const history = useHistory();
  const classes = useStyles();
  const { id } = useParams();
  const storedToken = localStorage.getItem('tokenThingwings');
  const language = useSelector(state => state.language.language);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [openSnackbar, setOpenSnackbar] = useState(null);
  const [loading, setLoading] = useState(false);
  const [hideDrawer, setHideDrawer] = useState(() => localStorage.getItem('hideDrawer') === 'true');


  const handleCloseSnackbar = () => {
    setOpenSnackbar(null);
  };

  useEffectAsync(async () => {
    if (id) {
      const response = await fetch(`/api/${endpoint}/${id}`);
      if (response.ok) {
        const  res = await response.json();
        setItem(res);
      }
    } else {
      setItem({});
    }

  }, [id]);

  const fetchData = async (url, item, id, storedToken, organ) => {
    try {
      const response = await fetch(url, {
        method: !id ? 'POST' : 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Auth-Token': 'Bearer ' + storedToken,
          'organization': organ,
        },
        body: JSON.stringify(item),
      });
      return response;
    } catch (error) {
      console.error('Fetch error:', error.message);
      throw error;
    }
  };

  const urlFull = () => {
    let url = `/api/${endpoint}`;
    if (id) {
      if (endpoint === 'devices')
        url += `/device/${id}`;
      else if (endpoint === "users")
        url += `/updateuser/${id}`;
      else
        url += `/${id}`;
    }
    else if (endpoint === "users")
      url += `/addUser`;
    else if (endpoint === "devices")
      url += `/adddevice`;
    return url;
  }

  const handleSave = async () => {
    let organ;
    if (id) {
      if (endpoint === "users") {
        if (item.organization) {
          organ = item.organization;
          delete item.organization;
        }
      }
      if (endpoint === "devices"){
        const speedLimit = item.attributes?.speedLimit;
        if (speedLimit !== undefined && (speedLimit === '' || isNaN(Number(speedLimit)) || speedLimit < 1)) {
          setOpenSnackbar('speedLimitNotValid')
          return;
        }
      }
    }
    else if (endpoint === "users") {
      if (!item.name || !item.email || !item.password || !item.phone) {
        setOpenSnackbar('RequiredFiling')
        return;
      } else if (item.password.length < 6){
        setOpenSnackbar('lessSixCharacter')
        return;
      }
    }

    if (endpoint === "devices" && item?.name?.length > 15) {
      setOpenSnackbar('namePassedLimitLetters')
      return;
    }
    setLoading(true)
    let response =  await fetchData(urlFull(), item, id, storedToken, organ)
    if (response)
      setLoading(false)

    if (response.ok) {
      history.goBack();
    }
    else if (response.status === 400){
      const errorText = await response.text();
      if(errorText.includes("ERROR: duplicate key"))
        setOpenSnackbar("tryAnotherEmail")
      else{
        let spliteText = errorText.split(' ')[0];
        setOpenSnackbar(spliteText)
      }
    }
    else
      setOpenSnackbar('UnknownProblem')
  };

  return (
      <div className={classes.settingRoot}>
        <CssBaseline />

        {!isMobile && <div className={classes.appBarWrapper}>
          <MainToolbar/>
        </div>}

        <SettingsDrawer hideDrawer={hideDrawer} setHideDrawer={setHideDrawer} page={endpoint}/>

        <main className={classes.content}>
          <div className={classes.toolbarSpacer} style={{marginBottom: theme.spacing(2)}} />
          <Container maxWidth="md" className={classes.container}>
            <div className={classes.formWrapper}>
              {children}
              <FormControl fullWidth margin='normal'>
                {(endpoint !== 'devices' || id === undefined || (item != null && item.configured !== "should_delete_C" && item.configured !== "should_delete_N")) && (
                    <div className={classes.buttons}>
                      <Button className={`${classes.cyberButtonRemoveDialog} ${classes.cancelButtonRemoveDialog}`} variant='outlined' onClick={() => history.goBack()}>
                        {t('sharedCancel')}
                      </Button>
                      <Button className={`${classes.cyberButtonRemoveDialog} ${classes.saveButtonRemoveDialog}`} variant='outlined' onClick={handleSave}>
                        {endpoint === "devices" && id !== undefined && item.configured!=="configured" ? (t(item.configured+"Ok") ): (t('sharedSave')) }
                      </Button>
                    </div>
                )}
              </FormControl>
            </div>
          </Container>
        </main>

        <Portal disablePortal={false}>
          <Snackbar
              open={!!openSnackbar}
              autoHideDuration={12000}
              onClose={handleCloseSnackbar}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
              dir={language === 'ar' || language === 'fa' ? 'rtl' : 'ltr'}
              style={{ zIndex: 9999 }}
          >
            <Alert onClose={handleCloseSnackbar} variant="filled" severity="error">
              {t(openSnackbar)}
            </Alert>
          </Snackbar>
        </Portal>

        {loading &&
            <div className={classes.loading}>
              <CircularProgress color="secondary"  size={60} thickness={4}/>
            </div>
        }
      </div>
  );
}

export default EditItemView;
